module.exports = __webpack_public_path__ + "static/media/LogoImageMobileWhite.a1c0d105.svg";